<template>
    <div class="date-picker" ref="field" @focusin="onFocusin" tabindex="0">
        <div class="date-picker__wrap" >
            <a-input
                :label="label"
                :placeholder="placeholder"
                :name="name"
                :error="error"
                :staticLabel="staticLabel"
                :modelValue="range && modelValue ? modelValue.start + ' - ' + modelValue.end : modelValue"
                :readonly="!useManualInput"
            >
                <template #append>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="mode === 'date'">
                        <path d="M2.91705 22H18.2682C19.8774 22 21.1852 20.6922 21.1852 19.083V4.54665C21.1852 2.93739 19.8774 1.6296 18.2682 1.6296H17.1111V0.8148C17.1111 0.366646 16.7444 0 16.2963 0C15.8481 0 15.4815 0.366646 15.4815 0.8148V1.6296H5.70373V0.8148C5.70373 0.366646 5.33702 0 4.88887 0C4.44071 0 4.07407 0.366646 4.07407 0.8148V1.6296H2.91705C1.30779 1.6296 0 2.93739 0 4.54665V19.083C0 20.6922 1.30779 22 2.91705 22V22ZM1.62967 4.54665C1.62967 3.83778 2.20818 3.25927 2.91705 3.25927H4.07407V4.07407C4.07407 4.52222 4.44071 4.88887 4.88887 4.88887C5.33702 4.88887 5.70367 4.52222 5.70367 4.07407V3.25927H15.4815V4.07407C15.4815 4.52222 15.8481 4.88887 16.2963 4.88887C16.7444 4.88887 17.1111 4.52222 17.1111 4.07407V3.25927H18.2681C18.977 3.25927 19.5555 3.83778 19.5555 4.54665V19.083C19.5555 19.7918 18.977 20.3703 18.2681 20.3703H2.91705C2.20818 20.3703 1.62967 19.7918 1.62967 19.083V4.54665Z" fill="#68737D"/>
                        <path d="M5.90912 9.3705C6.47163 9.3705 6.92762 8.9145 6.92762 8.352C6.92762 7.78949 6.47163 7.3335 5.90912 7.3335C5.34662 7.3335 4.89062 7.78949 4.89062 8.352C4.89062 8.9145 5.34662 9.3705 5.90912 9.3705Z" fill="#68737D"/>
                        <path d="M10.3857 9.3705C10.9482 9.3705 11.4042 8.9145 11.4042 8.352C11.4042 7.78949 10.9482 7.3335 10.3857 7.3335C9.82319 7.3335 9.36719 7.78949 9.36719 8.352C9.36719 8.9145 9.82319 9.3705 10.3857 9.3705Z" fill="#68737D"/>
                        <path d="M14.8701 9.3705C15.4326 9.3705 15.8886 8.9145 15.8886 8.352C15.8886 7.78949 15.4326 7.3335 14.8701 7.3335C14.3076 7.3335 13.8516 7.78949 13.8516 8.352C13.8516 8.9145 14.3076 9.3705 14.8701 9.3705Z" fill="#68737D"/>
                        <path d="M5.90912 13.4442C6.47163 13.4442 6.92762 12.9882 6.92762 12.4257C6.92762 11.8632 6.47163 11.4072 5.90912 11.4072C5.34662 11.4072 4.89062 11.8632 4.89062 12.4257C4.89062 12.9882 5.34662 13.4442 5.90912 13.4442Z" fill="#68737D"/>
                        <path d="M10.3857 13.4442C10.9482 13.4442 11.4042 12.9882 11.4042 12.4257C11.4042 11.8632 10.9482 11.4072 10.3857 11.4072C9.82319 11.4072 9.36719 11.8632 9.36719 12.4257C9.36719 12.9882 9.82319 13.4442 10.3857 13.4442Z" fill="#68737D"/>
                        <path d="M14.8701 13.4442C15.4326 13.4442 15.8886 12.9882 15.8886 12.4257C15.8886 11.8632 15.4326 11.4072 14.8701 11.4072C14.3076 11.4072 13.8516 11.8632 13.8516 12.4257C13.8516 12.9882 14.3076 13.4442 14.8701 13.4442Z" fill="#68737D"/>
                        <path d="M5.90912 17.5184C6.47163 17.5184 6.92762 17.0624 6.92762 16.4999C6.92762 15.9374 6.47163 15.4814 5.90912 15.4814C5.34662 15.4814 4.89062 15.9374 4.89062 16.4999C4.89062 17.0624 5.34662 17.5184 5.90912 17.5184Z" fill="#68737D"/>
                        <path d="M10.3857 17.5184C10.9482 17.5184 11.4042 17.0624 11.4042 16.4999C11.4042 15.9374 10.9482 15.4814 10.3857 15.4814C9.82319 15.4814 9.36719 15.9374 9.36719 16.4999C9.36719 17.0624 9.82319 17.5184 10.3857 17.5184Z" fill="#68737D"/>
                        <path d="M14.8701 17.5184C15.4326 17.5184 15.8886 17.0624 15.8886 16.4999C15.8886 15.9374 15.4326 15.4814 14.8701 15.4814C14.3076 15.4814 13.8516 15.9374 13.8516 16.4999C13.8516 17.0624 14.3076 17.5184 14.8701 17.5184Z" fill="#68737D"/>
                    </svg>
                    <svg v-else-if="mode === 'time'" width="22" height="22" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="#68737D">
                        <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </template>
            </a-input>
        </div>
        <transition :name="`date-picker__trans-${state.transition.dir}`">
            <div class="date-picker__dropdown" v-if="state.show">
                <div class="date-picker__backdrop" @click="hide"></div>
                <DatePicker
                    v-if="mode === 'date'"
                    v-model="modelValue"
                    title-position="left"
                    :min-date="minDate"
                    :is-range="range"
                    :model-config="{
                        type: 'string',
                        mask: 'DD.MM.YYYY',
                    }"
                />
                <div v-else class="vc-container time-picker">
                    <div class="time-picker__wrap">
                        <div class="flex v-center">
                            <a-select
                                class="time-picker__select"
                                v-model="state.time.h"
                                :options="hours"
                                value="value"
                                display="display"
                                label=""
                            />
                            <div class="time-picker__delimeter">:</div>
                            <a-select
                                class="time-picker__select"
                                v-model="state.time.min"
                                :options="mins"
                                value="value"
                                display="display"
                                label=""
                            />
                            <a-btn label="OK" type="button" class="secondary" @click="timeSubmit" />
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue'
import IMask from 'imask';
import { AInput, ASelect, ABtn } from '../index'
import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

export default {
    name: 'ADatePicker',
    props: {
        modelValue: {
            default: null,
        },
        label: String,
        staticLabel: {
            type: Boolean,
            default: false,
        },
        hint: String,
        error: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'date',
        },
        minDate: {
            default: null,
        },
        range: {
            type: Boolean,
            default: false,
        },
        useManualInput: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AInput,
        ASelect,
        ABtn,
        DatePicker,
        IMask
    },
    setup: (props, ctx) => {

        const field = ref(null)
        const state = ref({
            show: false,
            transition: {
                dir: 'up',
            },
            time: {
                h: '00',
                min: '00',
            },
        })

        const hours = computed(() => {
            let data = []
            for(let i = 0; i < 24; i++) {
                data.push({
                    value: i < 10 ? `0${i}` : `${i}`,
                    display: i < 10 ? `0${i}` : `${i}`,
                })
            }

            return data
        })

        const mins = computed(() => {
            let data = []
            for(let i = 0; i < 12; i++) {
                data.push({
                    value: i * 5 < 10 ? `0${i * 5}` : `${i * 5}`,
                    display: i * 5 < 10 ? `0${i * 5}` : `${i * 5}`,
                })
            }

            return data
        })

        const onFocusin = () => {
            state.value.transition.dir = 'up'
            state.value.show = true
        }

        const hide = () => {
            state.value.transition.dir = 'down'
            state.value.show = false
            field?.value?.blur()
        }

        const clickOutside = (e) => {
            if(!e.target.closest('.date-picker__dropdown') && !e.target.closest('.a-dropdown')) {
                hide()
            }
        }

        onMounted(() => {
            document.addEventListener('mousedown', clickOutside)

            if(props.useManualInput && !props.range) {
                const element = field.value.querySelector('input.input');
                const maskOptions = {
                    // mask: '00.00.0000'
                    mask: Date,  // enable date mask

                    // you can provide your own blocks definitions, default blocks for date mask are:
                    blocks: {
                        d: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31,
                            maxLength: 2,
                        },
                        m: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12,
                            maxLength: 2,
                        },
                        Y: {
                            mask: IMask.MaskedRange,
                            from: 1900,
                            to: 2099,
                        }
                    },
                };
                const mask = IMask(element, maskOptions);

                mask.on("complete", () => {
                    ctx.emit('update:modelValue', mask.value)
                });
            }
        })

        onUnmounted(() => {
            document.removeEventListener('mousedown', clickOutside)
        })

        const timeSubmit = () => {
            ctx.emit('update:modelValue', `${state.value.time.h}:${state.value.time.min}`)
            hide()
        }

        watch(
            () => props.modelValue,
            (val) => {
                ctx.emit('update:modelValue', val)
                hide()
            }
        )

        return {
            field,
            state,
            onFocusin,
            hide,
            hours,
            mins,
            timeSubmit,
        }
    },
}
</script>

<style lang="scss">
    .date-picker {
        position: relative;

        .label {
            white-space: nowrap;
        }
        .control-wrap {
            //pointer-events: none;
        }

        &__dropdown {
            position: absolute;
            top: calc(100% + 10px);
            left: 0;
            width: auto;
            min-width: 100%;
            z-index: 100;

            @include mobile {
                position: fixed;
                display: flex;
                align-items: flex-end;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 999;
            }

            .vc-container {
                width: 100%;

                @include mobile {
                    transition: all .3s cubic-bezier(0.215,0.61,0.355,1) 0s;
                    padding-top: 30px;
                    max-width: initial;
                    border-radius: 22px 22px 0px 0px;
                    z-index: 2;
                }
            }
        }
        &__backdrop {
            @include mobile {
                transition: transform .3s cubic-bezier(0.215,0.61,0.355,1);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgb(47, 57, 65, .85);
                z-index: 1;
            }
        }

        &__trans {

            &-up,
            &-down {
                &-enter-active,
                &-leave-active {
                    transition: all .3s cubic-bezier(0.215,0.61,0.355,1) 0s;
                }

                &-enter-active,
                &-leave-active {
                    transition: transform .3s cubic-bezier(0.215,0.61,0.355,1);
                }
            }

            &-up {
                &-enter-from {
                    .date-picker__backdrop {
                        @include mobile {
                            opacity: 1;
                        }
                    }
                    .vc-container {
                        @include mobile {
                            transform: translate3d(0, 100%, 0);
                        }
                    }
                }
                &-leave-to {
                    .date-picker__backdrop {
                        @include mobile {
                            opacity: 0;
                        }
                    }
                    .vc-container {
                        @include mobile {
                            transform: translate3d(0, -100%, 0);
                        }
                    }
                }
            }

            &-down {
                &-enter-from {
                    .date-picker__backdrop {
                        @include mobile {
                            opacity: 1;
                        }
                    }
                    .vc-container {
                        @include mobile {
                            transform: translate3d(0, 0%, 0);
                        }
                    }
                }
                &-leave-to {
                    .date-picker__backdrop {
                        @include mobile {
                            opacity: 0;
                        }
                    }
                    .vc-container {
                        @include mobile {
                            transform: translate3d(0, 100%, 0);
                        }
                    }
                }
            }

        }
    }
    .time-picker {
        padding: 10px;
        @include mobile {
            padding-bottom: 40px;
        }
        &__wrap {
            width: 100%;
        }
        .flex {
            width: 100%;
            @include mobile {
                flex-wrap: wrap;
            }
        }
        &__select {
            .control-wrap {
                pointer-events: initial;
            }
        }
        &__delimeter {
            margin: 0 8px;
        }
        .field {
            margin: 0;
            @include mobile {
                flex: 1000 0 0;
            }
        }
        .a-btn {
            margin-left: 8px;
            @include mobile {
                width: 100%;
                margin: 16px 0 0 0;
            }
        }

    }
</style>